import { render } from "./GameSelection.vue?vue&type=template&id=d86e4bf4&scoped=true"
import script from "./GameSelection.vue?vue&type=script&lang=js"
export * from "./GameSelection.vue?vue&type=script&lang=js"

import "./GameSelection.vue?vue&type=style&index=0&id=d86e4bf4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d86e4bf4"]])

export default __exports__